"use client";

import { styled } from "@mui/material/styles";
import TableContainer from "@mui/material/TableContainer";

import {
  COLOR_GREYSCALE_NTA_BLACK_50,
  COLOR_GREYSCALE_NTA_BLACK_8,
  COLOR_ADDITIONAL_WARM_GRAY_3U,
} from "~/theme/colors";

import { SIZE_TABLE_CLASSES } from "./constants";

export const SizeTableContainer = styled(TableContainer)(({ theme }) => {
  return {
    borderTop: `1px solid ${COLOR_GREYSCALE_NTA_BLACK_8}`,
    borderLeft: `1px solid ${COLOR_GREYSCALE_NTA_BLACK_8}`,
    borderBottom: `1px solid ${COLOR_GREYSCALE_NTA_BLACK_8}`,
    [`& .${SIZE_TABLE_CLASSES.table}`]: {
      borderCollapse: "collapse",
    },
    [`& .${SIZE_TABLE_CLASSES.cell}`]: {
      minWidth: 74,
      borderBottom: "none",
      boxShadow: `
        inset 0 1px 0 0 ${COLOR_GREYSCALE_NTA_BLACK_8},
        inset -1px 0 0 0 ${COLOR_GREYSCALE_NTA_BLACK_8}
      `,
      padding: theme.spacing(1.25),
      "&:nth-of-type(odd)": {
        boxShadow: `
          inset -1px 0 0 0 ${COLOR_GREYSCALE_NTA_BLACK_8},
          inset 0 1px 0 0 ${COLOR_GREYSCALE_NTA_BLACK_8}
        `,
      },
    },
    [`& .${SIZE_TABLE_CLASSES.firstCell}`]: {
      position: "sticky",
      left: 0,
      boxShadow: `inset -1px 0 0 0 ${COLOR_GREYSCALE_NTA_BLACK_50} !important`,
      padding: theme.spacing(1.25),
    },
    [`& .${SIZE_TABLE_CLASSES.firstColumn}`]: {
      borderBottom: "none",
      boxShadow: `
        inset -1px 0 0 0 ${COLOR_GREYSCALE_NTA_BLACK_50},
        inset 0 1px 0 0 ${COLOR_GREYSCALE_NTA_BLACK_8}
      `,
      ...theme.typography.body2,
      background: COLOR_ADDITIONAL_WARM_GRAY_3U,
      position: "sticky",
      left: 0,
      padding: theme.spacing(1.25),
    },
    [`& .${SIZE_TABLE_CLASSES.head}`]: {
      minWidth: 74,
      background: COLOR_ADDITIONAL_WARM_GRAY_3U,
      borderTop: "none",
      borderBottom: "none",
      padding: theme.spacing(1.25),
      ...theme.typography.body2,
      "&:nth-of-type(n + 1)": {
        boxShadow: `inset -1px 0 0 0 ${COLOR_GREYSCALE_NTA_BLACK_8}`,
      },
    },
  };
});
